import { useNavigate } from "react-router-dom";
import "../pages/LandingPage.css";

export const PublicNav = () => {
  const navigate = useNavigate();
  return (
    <header className="lp-nav">
      <div className="lp-nav-logo" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
        Ad<span>soar</span>
      </div>
      <nav className="lp-nav-links">
        <button className="lp-nav-link" onClick={() => navigate("/")}>Home</button>
        <button className="lp-nav-link" onClick={() => navigate("/pricing")}>Pricing</button>
        <button className="lp-nav-link" onClick={() => navigate("/contact")}>Contact</button>
      </nav>
      <div className="lp-nav-actions">
        <button className="lp-btn-ghost" onClick={() => navigate("/login")}>Log in</button>
        <button className="lp-btn-primary" onClick={() => navigate("/signup")}>Get Started Free</button>
      </div>
    </header>
  );
};

export const PublicFooter = () => (
  <footer className="lp-footer">
    <div className="lp-footer-inner">
      <div className="lp-footer-col">
        <div className="lp-footer-logo">Ad<span>soar</span></div>
        <p className="lp-footer-text">Simplifying Facebook ads for marketers and business owners.</p>
      </div>
      <div className="lp-footer-col">
        <div className="lp-footer-heading">Product</div>
        <a href="/pricing" className="lp-footer-link">Pricing</a>
      </div>
      <div className="lp-footer-col">
        <div className="lp-footer-heading">Company</div>
        <a href="/contact" className="lp-footer-link">Contact</a>
      </div>
      <div className="lp-footer-col">
        <div className="lp-footer-heading">Legal</div>
        <a href="/privacy" className="lp-footer-link">Privacy Policy</a>
        <a href="/terms" className="lp-footer-link">Terms of Service</a>
      </div>
    </div>
    <div className="lp-footer-bottom">
      © {new Date().getFullYear()} Adsoar. All rights reserved.
    </div>
  </footer>
);
